document.addEventListener('DOMContentLoaded', () => {
  const triggers = document.querySelectorAll('.video-popup');
  
  if (!document.querySelector('.video-gallery-modal')) {
      const modalHTML = `
        <div class="video-gallery-modal" role="dialog" aria-modal="true" aria-label="Video Player">
            <div class="modal-content">
                <button class="modal-close" aria-label="Close">&times;</button>
                <div class="video-wrapper"></div>
            </div>
        </div>
      `;
      document.body.insertAdjacentHTML('beforeend', modalHTML);
  }

  const modal = document.querySelector('.video-gallery-modal');
  const videoWrapper = modal.querySelector('.video-wrapper');
  const closeBtn = modal.querySelector('.modal-close');

  function getYouTubeId(url) {
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    return (match && match[2].length === 11) ? match[2] : null;
  }

  function openModal(link) {
    let content = '';
    const youtubeId = getYouTubeId(link);

    if (youtubeId) {
        content = `<iframe src="https://www.youtube.com/embed/${youtubeId}?autoplay=1" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
    } else {
        content = `<video controls autoplay src="${link}" style="width:100%; height:100%"></video>`;
    }
    
    videoWrapper.innerHTML = content;
    modal.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
      modal.classList.remove('open');
      setTimeout(() => {
        videoWrapper.innerHTML = '';
      }, 300);
      document.body.style.overflow = '';
  }

  triggers.forEach(trigger => {
      trigger.addEventListener('click', (e) => {
          e.preventDefault();
          const href = trigger.getAttribute('href');
          if(href) openModal(href);
      });
  });

  closeBtn.addEventListener('click', closeModal);
  
  modal.addEventListener('click', (e) => {
      if (e.target === modal) closeModal();
  });
  
  document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.classList.contains('open')) {
          closeModal();
      }
  });

  const searchInput = document.getElementById('video-gallery-search');
  const sortSelect = document.getElementById('video-gallery-sort');
  const categorySelect = document.getElementById('video-gallery-category');
  const categorySections = Array.from(document.querySelectorAll('.category-section'));

  function checkExpandButton(section) {
      const gallery = section.querySelector('.video-gallery');
      const expandBtn = section.querySelector('.expand-button');
      const items = Array.from(gallery.querySelectorAll('.gallery-item'));
      const visibleItems = items.filter(item => item.style.display !== 'none');
      
      const computedStyle = window.getComputedStyle(gallery);
      const columns = computedStyle.getPropertyValue('grid-template-columns').split(' ').length;
      const rows = Math.ceil(visibleItems.length / columns);
      
      if (rows > 2) {
          expandBtn.style.display = 'block';
          gallery.classList.add('collapsed');
      } else {
          expandBtn.style.display = 'none';
          gallery.classList.remove('collapsed', 'expanded');
      }
  }

  categorySections.forEach(section => {
      const expandBtn = section.querySelector('.expand-button');
      const gallery = section.querySelector('.video-gallery');
      
      if (expandBtn) {
          expandBtn.addEventListener('click', () => {
              if (gallery.classList.contains('collapsed')) {
                  gallery.classList.remove('collapsed');
                  gallery.classList.add('expanded');
                  expandBtn.classList.add('expanded');
              } else {
                  gallery.classList.remove('expanded');
                  gallery.classList.add('collapsed');
                  expandBtn.classList.remove('expanded');
                  section.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }
          });
      }
      
      checkExpandButton(section);
  });

  window.addEventListener('resize', () => {
      categorySections.forEach(section => {
          checkExpandButton(section);
      });
  });

  function filterAndSort() {
      const searchTerm = searchInput ? searchInput.value.toLowerCase() : '';
      const sortValue = sortSelect ? sortSelect.value : 'original';
      const categoryValue = categorySelect ? categorySelect.value : 'all';

      categorySections.forEach(section => {
          const sectionCategory = section.dataset.category;
          const gallery = section.querySelector('.video-gallery');
          const items = Array.from(gallery.querySelectorAll('.gallery-item'));
          
          let visibleCount = 0;

          items.forEach(item => {
              const title = item.querySelector('h3').textContent.toLowerCase();
              const description = item.querySelector('p').textContent.toLowerCase();
              const itemCategory = item.dataset.category || '';
              const itemLanguage = item.dataset.language || '';

              const matchesSearch = title.includes(searchTerm) || description.includes(searchTerm);
              const matchesCategory = categoryValue === 'all' || itemCategory === categoryValue;
              
              let matchesLanguage = true;
              if (sortValue === 'lang-fr') {
                  matchesLanguage = itemLanguage === 'fr';
              } else if (sortValue === 'lang-en') {
                  matchesLanguage = itemLanguage === 'en';
              }

              if (matchesSearch && matchesCategory && matchesLanguage) {
                  item.style.display = '';
                  visibleCount++;
              } else {
                  item.style.display = 'none';
              }
              
              gallery.appendChild(item);
          });

          section.style.display = visibleCount > 0 ? '' : 'none';
          
          if (visibleCount > 0) {
              checkExpandButton(section);
          }
      });
  }

  if (searchInput) {
      searchInput.addEventListener('input', filterAndSort);
  }

  if (sortSelect) {
      sortSelect.addEventListener('change', filterAndSort);
  }

  if (categorySelect) {
      categorySelect.addEventListener('change', filterAndSort);
  }
});